export enum LineType {
    Solid = "Solid",
    Dashed = "Dashed",
    Dotted = "Dotted",
    SmallDash = "SmallDash",
    LargeDash = "LargeDash"
}